import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "reservation-summary mt-custom p-2 p-md-4 bg-blue-100"
}
const _hoisted_2 = { class: "title-4 mb-3" }

import { onMounted, computed, PropType } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex' // 1) Import useStore
  import { useServiceCategorization } from '@/composables/useServiceCategorization'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'
  import { BookingStatus } from '@/config'

  // Icons
  import AccommodationIcon from '@/assets/AccommondationIcon.vue'
  import SkipassIcon from '@/assets/SkipassIcon.vue'
  import EquipmentIcon from '@/assets/EquipmentIcon.vue'
  import HelmetIcon from '@/assets/HemletIcon.vue'
  import OptionIcon from '@/assets/OptionIcon.vue'
  import TrainIcon from '@/assets/TrainIcon.vue'
  import TransferIcon from '@/assets/TransferIcon.vue'
  import PlaneIcon from '@/assets/PlaneIcon.vue'
  import LuggageIcon from '@/assets/LuggageIcon.vue'

  // Skeleton  component (replace with your a new one)
  import ReservationsSkeleton from '../ConfirmedReservations/ReservationsSkeleton.vue'
  import OptionList from './OptionList.vue'
  import PriceAndQuoteButton from './PriceAndQuoteButton.vue'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationSummary',
  props: {
    booking: {
      type: Object as PropType<BookingSummary>,
      required: true,
    },
    hideActionButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  const props = __props

  // i18n instance
  const { t } = useI18n()

  // 2) Access the Vuex store & create a local isLoading computed
  const store = useStore()
  const isServicesLoading = computed(() =>
    store.getters['catalog/isLoading']('fetchServices')
  )

  // Use Composable
  const { groupedOptions, fetchServices } = useServiceCategorization(
    props.booking
  )

  // Fetch services on mounted
  onMounted(async () => {
    await fetchServices()
  })

  const showQuoteOrCartBlock = computed(() =>
    [BookingStatus.Quote, BookingStatus.CartInProgress].includes(
      props.booking.status
    )
  )

  // Computed for building the OptionList
  const optionList = computed(() => [
    {
      options: groupedOptions.value.accommodation,
      sectionTitle: t('reservations.accommodation'),
      iconComponent: AccommodationIcon,
    },
    {
      options: groupedOptions.value.train,
      sectionTitle: t('reservations.train'),
      iconComponent: TrainIcon,
    },
    {
      options: groupedOptions.value.flight,
      sectionTitle: t('reservations.flight'),
      iconComponent: PlaneIcon,
    },
    {
      options: groupedOptions.value.transfert,
      sectionTitle: t('reservations.transfer'),
      iconComponent: TransferIcon,
    },
    {
      options: groupedOptions.value.luggage,
      sectionTitle: t('reservations.luggage'),
      iconComponent: LuggageIcon,
    },
    {
      options: groupedOptions.value.skipass,
      sectionTitle: t('reservations.skipass'),
      iconComponent: SkipassIcon,
    },
    {
      options: groupedOptions.value.material,
      sectionTitle: t('reservations.equipment'),
      iconComponent: EquipmentIcon,
    },
    {
      options: groupedOptions.value.helmet,
      sectionTitle: t('reservations.helmet'),
      iconComponent: HelmetIcon,
    },
    {
      options: groupedOptions.value.option,
      sectionTitle: t('reservations.option'),
      iconComponent: OptionIcon,
    },
  ])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isServicesLoading.value)
      ? (_openBlock(), _createBlock(ReservationsSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('reservations.summaryTitle')), 1),
          _createVNode(OptionList, { options: optionList.value }, null, 8, ["options"]),
          (showQuoteOrCartBlock.value)
            ? (_openBlock(), _createBlock(PriceAndQuoteButton, {
                key: 0,
                booking: __props.booking,
                buttonText: _unref(t)('reservations.reserve'),
                "hide-action-button": __props.hideActionButton
              }, null, 8, ["booking", "buttonText", "hide-action-button"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})